import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import DonateButton from '../DonateButton/DonateButton';
import styles from './Header.module.css';
import logo from '../../assets/images/logo.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* Logo */}
        <Link to="/" className={styles.logo} onClick={closeMenu}>
          <img src={logo} alt="IMDF Logo" className={styles.logoImage} />
          <div className={styles.logoTextWrapper}>
            <span className={styles.logoText}>IMDF</span>
            <span className={styles.logoMotto}>Towards a Healthy Idoma Nation</span>
          </div>
        </Link>

        {/* Mobile Menu Toggle */}
        <button
          className={styles.menuToggle}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className={styles.hamburger}></span>
        </button>

        {/* Navigation */}
        <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            <li><NavLink to="/" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Home</NavLink></li>
            <li><NavLink to="/about" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>About</NavLink></li>
            <li><NavLink to="/leadership" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Leadership</NavLink></li>
            <li><NavLink to="/membership" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Membership</NavLink></li>
            <li><NavLink to="/activities" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Activities</NavLink></li>
            <li><NavLink to="/publications" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Publications</NavLink></li>
            <li><NavLink to="/contact" className={({ isActive }) => (isActive ? styles.activeLink : '')} onClick={closeMenu}>Contact</NavLink></li>
            <li className={styles.donateMobile}>
              <DonateButton onClick={closeMenu} />
            </li>
            <li className={styles.loginMobile}>
              <Link to="/login" onClick={closeMenu}>Login</Link>
            </li>
          </ul>
        </nav>

        {/* Desktop Actions */}
        <div className={styles.actions}>
          <Link to="/login" className={styles.loginLink}>Login</Link>
          <DonateButton />
        </div>
      </div>
    </header>
  );
};

export default Header;